import { DetailScrollReveal } from '~/ui-rocco/pages/detail-shared';
import { EditorialClosing } from '~/ui-rocco/pages/detail-shared';
import { ProfessionalNetworkGridSection } from './sections/ProfessionalNetworkGridSection';
import { ProfessionalContactSection } from './sections/ProfessionalContactSection';

/**
 * BC-4572 — revamped professional Network tab (/partners).
 *
 * Same editorial shell as the other revamped tabs (hero, sub-nav, "Talk to us"
 * and the About-ArchiPro closing), with a partner-professional tile grid as the
 * body. Rendered behind the revamp flag; the route serves overview-shaped data
 * so the reused sections + the grid get what they read.
 */
export const ProfessionalNetworkPageRevamp = () => {
    return (
        <main
            id="main-content"
            data-testid="professional-network-page-revamp"
            className="bg-white"
        >
            <DetailScrollReveal>
                <ProfessionalNetworkGridSection />
            </DetailScrollReveal>
            <ProfessionalContactSection />
            <EditorialClosing hideHero />
        </main>
    );
};
